// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"56":"politica","486":"bcompliance","717":"email","915":"empresas"}[chunkId] + "." + {"56":"2bb1c0a7","486":"8378757d","717":"c23d5d3b","915":"fcf9052c"}[chunkId] + ".js";
};